// Import and register all your controllers from the build
import { application } from "./application"

import CaptureDirectoryController from "./capture_directory_controller"
import CaptureHintController from "./capture_hint_controller"
import CaptureTagsController from "./capture_tags_controller"
import ClientAuditFormController from "./client_audit_form_controller"
import ContactIntakeController from "./contact_intake_controller"
import ContactFeedbackController from "./contact_feedback_controller"
import DeveloppementAnimationsController from "./developpement_animations_controller"
import DisclosureController from "./disclosure_controller"
import EmailComposerController from "./email_composer_controller"
import HomepageAnimationsController from "./homepage_animations_controller"
import HygieneChallengeController from "./hygiene_challenge_controller"
import InboxController from "./inbox_controller"
import IncidentTriageController from "./incident_triage_controller"
import MaturityDiagnosticController from "./maturity_diagnostic_controller"
import PageThemeController from "./page_theme_controller"
import PrintController from "./print_controller"
import ProjectEstimatorController from "./project_estimator_controller"
import ScrollRevealController from "./scroll_reveal_controller"
import SidebarController from "./sidebar_controller"
import SmoothScrollController from "./smooth_scroll_controller"
import ThemeToggleController from "./theme_toggle_controller"

application.register("capture-directory", CaptureDirectoryController)
application.register("capture-hint", CaptureHintController)
application.register("capture-tags", CaptureTagsController)
application.register("client-audit-form", ClientAuditFormController)
application.register("contact-intake", ContactIntakeController)
application.register("contact-feedback", ContactFeedbackController)
application.register("developpement-animations", DeveloppementAnimationsController)
application.register("disclosure", DisclosureController)
application.register("email-composer", EmailComposerController)
application.register("homepage-animations", HomepageAnimationsController)
application.register("hygiene-challenge", HygieneChallengeController)
application.register("inbox", InboxController)
application.register("incident-triage", IncidentTriageController)
application.register("maturity-diagnostic", MaturityDiagnosticController)
application.register("page-theme", PageThemeController)
application.register("print", PrintController)
application.register("project-estimator", ProjectEstimatorController)
application.register("scroll-reveal", ScrollRevealController)
application.register("sidebar", SidebarController)
application.register("smooth-scroll", SmoothScrollController)
application.register("theme-toggle", ThemeToggleController)
